<div class="icon-switch">
  @for (option of options; track option.value) {
    <button
      type="button"
      class="icon-switch__button"
      [class.is-active]="selectedValue === option.value"
      (click)="select(option.value)"
    >
      @if (option.iconImageUrl) {
        <span
          class="icon-switch__image-icon"
          [style.mask-image]="'url(' + option.iconImageUrl + ')'"
          [style.-webkit-mask-image]="'url(' + option.iconImageUrl + ')'"
        ></span>
      } @else if (option.iconClass) {
        <i [class]="option.iconClass"></i>
      }
    </button>
  }
</div>
